import {
  BookOpen, Zap, CheckCircle2, Users, FileText, CreditCard, Code, Lightbulb,
} from "lucide-react";
import { gettingStartedContent } from "./getting-started";
import { reviewModesContent } from "./review-modes";
import { clarityScoresContent } from "./clarity-scores";
import { personasContent } from "./personas";
import { projectsRunsContent } from "./projects-runs";
import { creditsBillingContent } from "./credits-billing";
import { apiReferenceContent } from "./api-reference";
import { bestPracticesContent } from "./best-practices";

export interface DocSection {
  slug: string;
  title: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  content: string;
}

export const docSections: DocSection[] = [
  {
    slug: "getting-started",
    title: "Getting Started",
    description: "Get up and running with Reqqy in under five minutes.",
    icon: BookOpen,
    content: gettingStartedContent,
  },
  {
    slug: "review-modes",
    title: "Review Modes",
    description: "Choose the depth of analysis that matches your needs.",
    icon: Zap,
    content: reviewModesContent,
  },
  {
    slug: "clarity-scores",
    title: "Clarity Scores",
    description: "Understand your requirements quality score from 0–100.",
    icon: CheckCircle2,
    content: clarityScoresContent,
  },
  {
    slug: "personas",
    title: "Personas",
    description: "Simulate different stakeholder perspectives in reviews.",
    icon: Users,
    content: personasContent,
  },
  {
    slug: "projects-runs",
    title: "Projects & Runs",
    description: "Organise reviews into projects and track improvements.",
    icon: FileText,
    content: projectsRunsContent,
  },
  {
    slug: "credits-billing",
    title: "Credits & Billing",
    description: "Understand the credit system and manage your usage.",
    icon: CreditCard,
    content: creditsBillingContent,
  },
  {
    slug: "api-reference",
    title: "API Reference",
    description: "Integrate Reqqy into your CI/CD pipeline and tools.",
    icon: Code,
    content: apiReferenceContent,
  },
  {
    slug: "best-practices",
    title: "Best Practices",
    description: "Tips for getting the most out of Reqqy.",
    icon: Lightbulb,
    content: bestPracticesContent,
  },
];
